module.exports = __webpack_public_path__ + "img/mendelu-logo.ba510019.png";